import { render, staticRenderFns } from "./DefinitionEditorDutySpecific.vue?vue&type=template&id=051aa9d2"
import script from "./DefinitionEditorDutySpecific.vue?vue&type=script&lang=ts"
export * from "./DefinitionEditorDutySpecific.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports